import { useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
} from '@mui/material';
import { Storage, Save, Cancel } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import SftpConnectionBasicInfoSection from './SftpConnectionBasicInfoSection';
import FormErrorSummary from '@/components/FormErrorSummary/FormErrorSummary';
import CpdActionButton from '@/components/ui/CpdActionButton';

const SftpConnectionFormDialog = ({
  open,
  onClose,
  organizationId,
  onSave,
  loading = false,
  fieldErrors = {},
  generalErrors = [],
}) => {
  const { t } = useTranslation();
  const basicInfoRef = useRef(null);

  const handleSave = () => {
    if (basicInfoRef.current) {
      onSave(basicInfoRef.current.formData);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        sx: { minHeight: '70vh' },
      }}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Storage color='primary' />
          {t('sftpConnections.createTitle')}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 3 }}>
          <FormErrorSummary errors={generalErrors} />
          <SftpConnectionBasicInfoSection
            ref={basicInfoRef}
            organizationId={organizationId}
            fieldErrors={fieldErrors}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 3 }}>
        <Button onClick={onClose} startIcon={<Cancel />}>
          {t('sftpConnections.cancel')}
        </Button>
        <CpdActionButton
          onClick={handleSave}
          loading={loading}
          startIcon={<Save sx={{ color: 'white' }} />}>
          {loading ? t('sftpConnections.saving') : t('sftpConnections.create')}
        </CpdActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default SftpConnectionFormDialog;
